<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >
        <v-card class="app-card app-form">
          <v-card-title class="app-card-title">
            <h4 class="text">
              <span>Detalhe Pagamento</span>
            </h4>
          </v-card-title>                    
          <v-card-text>
            <table>
              <tr>
                <td class="font-weight-bold pr-2 pt-2">ID:</td>
                <td class="pt-2">{{ detail.data.id ? detail.data.id : '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold pr-2 pt-2">Grupo:</td>
                <td class="pt-2">{{ detail.data.group.label ? detail.data.group.label : '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold pr-2 pt-2">Descrição:</td>
                <td class="pt-2">{{ detail.data.description ? detail.data.description : '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold pr-2 pt-2">Observação:</td>
                <td class="pt-2">{{ detail.data.observation ? detail.data.observation : '-' }}</td>
              </tr>              
              <tr>
                <td class="font-weight-bold pr-2 pt-2">Número Pedido:</td>
                <td class="pt-2">{{ detail.data.solicitation_id ? detail.data.solicitation_id : '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold pr-2 pt-2">Valor:</td>
                <td class="pt-2">{{ detail.data.value.formatted ? detail.data.value.formatted : '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold pr-2 pt-2">Empresa:</td>
                <td class="pt-2">{{ detail.data.company.name ? detail.data.company.name : '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold pr-2 pt-2">Status:</td>
                <td class="pt-2">
                  <v-chip                    
                    :color="paymentStatusColor(detail.data.status.raw)"
                    text-color="white"
                    v-if="detail.data.status"
                  >
                    {{ detail.data.status.label }}
                  </v-chip>
                  <span v-else>-</span>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold pr-2 pt-2">Data de Pagamento:</td>
                <td class="pt-2">{{ detail.data.paid_at.formatted ? detail.data.paid_at.formatted : '-' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold pr-2 pt-2">Data de Criação:</td>
                <td class="pt-2">{{ detail.data.created_at.formatted ? detail.data.created_at.formatted : '-' }}</td>
              </tr>
            </table>
          </v-card-text>
          <section
            v-if="detail.isLoading"
            class="loading"
          >
            <v-progress-circular
              indeterminate
              color="success"
            />
            <span>Enviando informações ...</span>
          </section>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import { paymentStatusColor } from '@/util/payment-status-color'; 

  export default {
    computed: {
      ...mapState('pagamento', ['detail'])
    },

    mounted() {
      this.initData();
    },

    destroyed() {
      this.clearResource();
    },

    methods: {
      paymentStatusColor(status) {
        return paymentStatusColor(status);
      },
      
      async initData() {
        const {
          params: { id }
        } = this.$route;
        await this.getPagamento(id);
      },

      ...mapActions('pagamento', { getPagamento: 'SHOW' }),
      ...mapActions('pagamento', { clearResource: 'CLEAR_DETAIL' })
    },
  };
</script>
